import { render, staticRenderFns } from "./RatesStats.vue?vue&type=template&id=213b6e0c&"
import script from "./RatesStats.vue?vue&type=script&lang=js&"
export * from "./RatesStats.vue?vue&type=script&lang=js&"
import style0 from "./RatesStats.vue?vue&type=style&index=0&id=213b6e0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports